import { ChevronLeft, ChevronRight } from "lucide-react";

export const Pagination = ({
    currentPage, 
    className = "" ,
    setCurrentPage,
    rowsPerPage, 
    totalPages,
    setRowsPerPage ,
    addJump = true , 
    jumpToPage ,
    pageJump , 
    setPageJump }) => {
    return (<div className={`flex flex-wrap gap-4 justify-between items-center mt-3 ${className}`}>
        {/* Rows per page selector */}
        <div>
            <label className="mr-2">Rows per page:</label>
            <select
                value={rowsPerPage}
                onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1); // reset page
                }}
                className="border rounded px-2 py-1 bg-white text-gray-800 border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 transition dark:bg-slate-800 dark:text-gray-100 dark:border-gray-700"
            >
                {[10, 20, 50].map((num) => (
                    <option key={num} value={num}>{num}</option>
                ))}
            </select>
        </div>

        {/* Pagination buttons */}
        <div className="flex flex-wrap items-center gap-2">
            <button
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    className="flex items-center gap-1 px-3 py-1 border rounded-xl hover:bg-green-600 hover:text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
  >
    <ChevronLeft size={16} />
    Prev
  </button>

            <span>
                Page {currentPage} of {totalPages}
            </span>
            {addJump && (<div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 dark:text-gray-300" htmlFor="page-jump">
                    Jump to
                </label>
                <input
                    id="page-jump"
                    type="number"
                    min="1"
                    max={totalPages}
                    value={pageJump}
                    onChange={(e) => setPageJump(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && jumpToPage()}
                    className="w-16 px-2 py-1 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-green-400 dark:border-gray-700 dark:bg-slate-800 dark:text-gray-100"
                />
                <button
                    onClick={jumpToPage}
                    className="px-3 py-1 border rounded bg-green-500 text-white hover:bg-green-600 transition"
                >
                    Go
                </button>
            </div>)}
             <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="flex items-center gap-1 px-3 py-1 border rounded-xl hover:bg-green-600 hover:text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
            Next
            <ChevronRight size={16} />
        </button>
        </div>
    </div>)
}